/** Katarina canvas painter stub. */
export class KatarinaPainter {
  static draw(ctx, entity, teamColor) {
    ctx.fillStyle = teamColor || '#ef4444';
    ctx.beginPath();
    ctx.arc(entity.x, entity.y, entity.radius || 20, 0, Math.PI * 2);
    ctx.fill();
  }
}
